import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import PickupCheckoutState from '../../types/PickupCheckoutState'

export const pickupCheckoutModule: Module<PickupCheckoutState, RootState> = {
  namespaced: true,
  state: {
    personalDetails: {
      firstName: '',
      lastName: '',
      emailAddress: '',
      password: '',
      createAccount: false
    },
    shippingDetails: {
      firstName: '',
      lastName: '',
      country: 'UA',
      streetAddress: '',
      apartmentNumber: '',
      city: 'Ternopil',
      state: 'Ternopil',
      region_id: 0,
      zipCode: '46000',
      phoneNumber: '',
      shippingMethod: '',
      comment: ''
    },
    deliveryTime: {
      datetime: '',
      asap: true
    },
    paymentDetails: {
      firstName: '',
      lastName: '',
      company: '',
      country: 'UA',
      streetAddress: '',
      apartmentNumber: '',
      city: 'Ternopil',
      state: 'Ternopil',
      region_id: 0,
      zipCode: '46000',
      phoneNumber: '',
      taxId: '',
      paymentMethod: '',
      paymentMethodAdditional: {}
    },
    isThankYouPage: false,
    modifiedAt: 0
  },
  getters,
  actions,
  mutations
}
